import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Status } from '../../services/apiTypes';

interface ManualState {
  status: Status;
  manuals: { [key: string]: string };
}

const initialState: ManualState = {
  status: 'idle',
  manuals: {},
};

const manualsSlice = createSlice({
  name: 'manuals',
  initialState,
  reducers: {
    addManual: (
      state,
      action: PayloadAction<{ typeId: string; manual: string }>,
    ) => {
      const { typeId, manual } = action.payload;
      state.manuals[typeId] = manual;
    },
    resetManuals: (state) => {
      state.manuals = {};
    },
  },
});

export const { addManual, resetManuals } = manualsSlice.actions;
export default manualsSlice.reducer;
